export const componentName = 'c-PaginatedSlider';
